import { cn } from '../../lib/utils';
import { ComponentProps, forwardRef } from 'react';

export const Shimmer = forwardRef<HTMLDivElement, ComponentProps<'div'>>(
  ({ className = '', ...props }, ref) => (
    <div ref={ref} className={cn('shimmer rounded-md', className)} {...props} />
  ),
);

Shimmer.displayName = 'Shimmer';
